import React from 'react'
import styled from 'styled-components'
import copy from 'copy-to-clipboard'
import { Modal, Button, Truncate, ModalInjectedProps } from '@sketch/components'

import { useToast } from '@sketch/toasts'
import { routes } from '@sketch/modules-common'

const StyledModal = styled(Modal)`
  width: 560px;
`

interface PreviewCreatedSuccessModalProps extends ModalInjectedProps {
  previewId: string
}

export const PreviewCreatedSuccessModal: React.FCC<
  PreviewCreatedSuccessModalProps
> = ({ hideModal, previewId }) => {
  const { showToast } = useToast()

  const handleCopyLink = () => {
    const previewPath = routes.PREVIEW_VIEW.create({ previewID: previewId })
    const fullUrl = `${window.location.origin}${previewPath}`
    copy(fullUrl)
    showToast('Preview link copied')
  }

  return (
    <StyledModal onCancel={hideModal}>
      <Modal.Header>Your preview is ready</Modal.Header>
      <Modal.Body>
        Anyone you share the link with can access it:{' '}
        <Truncate>
          <a
            href={`${window.location.origin}/preview/${previewId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {window.location.origin}/preview/{previewId}
          </a>
        </Truncate>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCopyLink}>
          Copy Link
        </Button>
        <Button variant="primary" onClick={hideModal}>
          Back to Document
        </Button>
      </Modal.Footer>
    </StyledModal>
  )
}
